import { createContext } from 'react';

const VehicleOverviewContext = createContext();

export default VehicleOverviewContext;
